"use client";

import { CircleUser } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar";
import { cn } from "~/lib/utils";

type OrganizationAvatarProps = {
  name?: string | null;
  imageUrl?: string | null;
  className?: string;
};

/**
 * Clerk org logos are often PNGs with transparency. Clerk previews them on white;
 * match that here so icons don't look broken on gray dropdown/hover backgrounds.
 */
export function OrganizationAvatar({
  name,
  imageUrl,
  className,
}: OrganizationAvatarProps) {
  const initial = name?.trim().charAt(0)?.toUpperCase() ?? "?";

  return (
    <Avatar
      className={cn(
        "shrink-0 overflow-hidden bg-white ring-1 ring-border/40",
        className,
      )}
    >
      {imageUrl ? (
        <AvatarImage
          src={imageUrl}
          alt={name ? `${name} logo` : "Organization logo"}
          className="object-contain p-[12%]"
        />
      ) : null}
      <AvatarFallback className="bg-muted text-[10px] font-semibold text-muted-foreground">
        {initial}
      </AvatarFallback>
    </Avatar>
  );
}

export function OrganizationAvatarOrPlaceholder({
  name,
  imageUrl,
  className,
}: OrganizationAvatarProps) {
  if (!name && !imageUrl) {
    return <CircleUser className={cn("shrink-0 text-muted-foreground", className)} />;
  }
  return <OrganizationAvatar name={name} imageUrl={imageUrl} className={className} />;
}
